import { useInitProvider } from 'providers/InitProvider';
import { useState } from 'react';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import { errorGenerator } from './errorGenerator';
import { generatoreCode } from './generateCode';

function propagateLogout() {
  try {
    const iFrame = document.getElementById('app-iframe') as HTMLIFrameElement;
    iFrame.contentWindow.postMessage({ action:'LOGOUT' }, '*');
  } catch (error) {
    console.error('Error propagating LOGOUT', error);
  }
}

function useSocketJSClient(onNewNotification) {
  const { dump } = useInitProvider();
  // const [data, setData] = useState(null);
  const [socket, setSocket] = useState<any | undefined>(undefined);
  // const [ws, setWS] = useState(null);
  const openSocket = () => {
    try {
      const { domain, path, appsReceiveChannel, systemReceiveChannel, token } =
        dump.shell.ws;

      //const sockJsProtocols = ["websocket"];
      const sjs = new SockJS(`${domain}${path}`);
      const sjs2 = new SockJS(`${domain}${path}`);
      const _socket = Stomp.over(sjs);
      const _socket2 = Stomp.over(sjs2);
      setSocket(_socket);

      _socket.connect(
        {},
        (frame) => {
          const url = `${appsReceiveChannel}/${token}`;
          _socket.subscribe(url, (data) => {
            try {
              console.log('Try to subscribe callback ', url, data.body);
              const notification = JSON.parse(data.body);
              // console.log('SUCCESS sub callback notification=', notification);
              onNewNotification(notification);
            } catch (error) {
              console.log('ERROR subscribing to websocket ', url, { error });
              const errorCode = generatoreCode(8).toString();
              errorGenerator(
                errorCode,
                error,
                '_socket.subscribe failure',
                '_socket.subscribe failure',
              );
            }
          });
        },
        (error) => {
          console.log('Connection error!', { error });
          const errorCode = generatoreCode(8).toString();
          errorGenerator(
            errorCode,
            error,
            '_socket.connect failure',
            '_socket.connect failure',
          );
        },
      );

      _socket2.connect(
        {},
        (frame) => {
          const url = `${systemReceiveChannel}/${token}`;
          _socket2.subscribe(url, (data) => {
            try {
              const objSocketSystem: { action: string } = JSON.parse(data.body);
              if (objSocketSystem.action === 'logout') {
                console.log(`Received LOGOUT action: ${data.body}`)
                propagateLogout();
                window.open('/rqx/session/logout', '_self');
              }
            } catch (error) {
              console.log('ERROR', { error });
              const errorCode = generatoreCode(8).toString();
              errorGenerator(
                errorCode,
                error,
                '_socket.subscribe failure',
                '_socket.subscribe failure',
              );
            }
          });
        },
        (error) => {
          console.log('Connection error!', { error });
          const errorCode = generatoreCode(8).toString();
          errorGenerator(
            errorCode,
            error,
            '_socket.connect failure',
            '_socket.connect failure',
          );
        },
      );
    } catch (error) {
      const errorCode = generatoreCode(8).toString();
      errorGenerator(
        errorCode,
        error,
        'openSocket failure',
        'openSocket failure',
      );
    }
  };

  const closeSocket = () => {
    try {
      // socket.disconnect(() => {
      //   console.log('disconnect');
      //   setSocket(undefined);
      // });
    } catch (error) {
      console.log({ error });
      const errorCode = generatoreCode(8).toString();
      errorGenerator(
        errorCode,
        error,
        'closeSocket failure',
        'closeSocket failure',
      );
    }
  };

  return {
    openSocket,
    closeSocket,
    socket,
  };
}

export default useSocketJSClient;
